import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { UsuarioService } from './usuarios.service';
import { UserTranslations, userTranslations } from './translations-usuarios';
import { getCurrentLanguage } from '../core/helpers/utils';
import { NotificationsService } from '../core/service/notifications.service';

// services
import { EventService } from 'src/app/core/service/event.service';

// constants
import { EventType } from 'src/app/core/constants/events';

// types
import { SortEvent } from 'src/app/shared/advanced-table/sortable.directive';
import { Column } from 'src/app/shared/advanced-table/advanced-table.component';
import { Usuario } from './usuarios.model';


@Component({
  selector: 'app-list-usuarios',
  templateUrl: './list-usuarios.component.html',
  styleUrls: ['./list-usuarios.component.scss']
})
export class ListUsuariosComponent implements OnInit, AfterViewInit {

  constructor(
    private eventService: EventService,
    private router: Router,
    private elRef: ElementRef,
    private usuariosService: UsuarioService,
    private notificationService: NotificationsService) { }

  records: Usuario[] = [];
  columns: Column[] = [];
  pageSizeOptions: number[] = [10, 25, 50, 100];

  // Botón de acción de la tabla
  currentLanguage: string = getCurrentLanguage()
  buttonTitle: string = '';
  buttonLink: string = 'usuarios/new';

  // Control de loading de la tabla cuando los usuarios hayan sido recibidos desde el backend
  loaded: boolean = false;

  // Control de errores
  error: string = '';

  // Animación de loading
  loading: boolean = false;

  // Para controlar las búsquedas
  allDatasearch: Usuario[] = []

  showConfirmDeleteModal: boolean = false;
  usuarioToDelete: Usuario | null = null;
  showConfirmEstadoModal: boolean = false;
  usuarioToEstado: Usuario | null = null;
  estadoAction: 'ACTIVAR' | 'DESACTIVAR' | null = null;

  ngAfterViewInit(): void {

  }
 

  ngOnInit(): void {
    //Le doy valor al botón
    const currentTranslations = userTranslations[this.currentLanguage].TABLE;
    this.buttonTitle = currentTranslations.BUTTON;

    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: currentTranslations.USUARIOS,
        breadCrumbItems: [{ label: currentTranslations.USUARIOS, path: '.', active: true }]
      }
    );
    this._fetchData();

  }

  /**
 * fetches table records
 */
  _fetchData(): void {
    this.usuariosService.getUsuarios("nivel_acceso=ADMIN").subscribe((res) => {
      this.records = res;
      //console.log("records",this.records)
      this.allDatasearch = this.records; // Guardo una copia de todos los datos para la búsqueda
      this.initTableCofig();
      this.loaded = true;
    },
      (error: string) => {
        this.error = error;
        this.loaded = false;
      });
  }

  /**
   * initialize advanced table columns
   */
  initTableCofig(): void {
    let currentLanguage: string = getCurrentLanguage()
    const currentTranslations = userTranslations[currentLanguage].TABLE;
    this.columns = [
      {
        name: 'nombre',
        label: currentTranslations.NAME,
        formatter: (record: Usuario) => record.nombre,
        width: 245,
      },
      {
        name: 'apellidos',
        label: currentTranslations.LAST_NAME,
        formatter: (record: Usuario) => record.apellidos,
        width: 400,
      },
      {
        name: 'validado',
        label: currentTranslations.VALIDADO,
        formatter: (record: Usuario) => record.validado,
        width: 30,
      },
      {
        name: 'activo',
        label: currentTranslations.ACTIVO,
        formatter: (record: Usuario) => record.activo,
        width: 30,
      },
      {
        name: 'accionesUsuarios',
        label: currentTranslations.ACTIONS,
        formatter: (record: Usuario) => null, // No es necesario enviar nada a advanced table porque la columna acciones está personalizada en el componente
        width: 360,
        sort: false
      }
    ];
  }

  // compares two cell values
  compare(v1: string | number, v2: string | number): any {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  /**
   * Sort the table data
   * @param event column name, sort direction
   */
  onSort(event: SortEvent): void {
    if (event.direction === '') {
      this.records = this.allDatasearch;
    } else {
      this.records = [...this.records].sort((a, b) => {
        const res = this.compare(a[event.column] as string | number, b[event.column] as string | number);
        return event.direction === 'asc' ? res : -res;
      });
    }
  }

  /**
* Recibe un texto y lo normaliza a lowercase y quita tildes para poder hacer búsquuedas
* @param text Texto a normalizar
*/
  normalizeText(text: string): string {
    return text.trim().toLocaleLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Normaliza letras con tilde
  }


  /**
 * Match table data with search input
 * @param row Table row
 * @param term Search the value
 */
  matches(row: Usuario, term: string) {
    return this.normalizeText(row.nombre as string).includes(this.normalizeText(term))
      || this.normalizeText(row.apellidos as string).includes(this.normalizeText(term))
  }

  /**
     * Search Method
    */
  searchData(searchTerm: string): void {
    if (searchTerm === '') {
      this.records = this.allDatasearch;
    }
    else {
      let updatedData = this.allDatasearch;

      //  filter
      updatedData = updatedData.filter(record => this.matches(record, searchTerm));
      //console.log("updatedData ->",updatedData)
      this.records = updatedData;
    }

  }

  openDeleteModal(usuario: Usuario) {
    this.usuarioToDelete = usuario;
    this.showConfirmDeleteModal = true;
  }

  closeDeleteModal() {
    this.showConfirmDeleteModal = false;
    this.usuarioToDelete = null;
  }

  confirmDelete() {
    if (this.usuarioToDelete?.id) {
      this.usuariosService.deleteUsuario(this.usuarioToDelete.id).subscribe(() => {
        const deleteUsuarioListSuccessMessage: string = $localize`:@@deleteUsuarioListSuccessMessage:Usuario borrado correctamente`;
        this.notificationService.showSuccessNotification(deleteUsuarioListSuccessMessage);
        this._fetchData();
        this.closeDeleteModal();
      });
    }
  }

  openEstadoModal(usuario: Usuario) {
    this.usuarioToEstado = usuario;
    this.estadoAction = usuario.activo === true ? 'DESACTIVAR' : 'ACTIVAR';
    this.showConfirmEstadoModal = true;
  }

  closeEstadoModal() {
    this.showConfirmEstadoModal = false;
    this.usuarioToEstado = null;
    this.estadoAction = null;
  }

  confirmEstado() {
    if (this.usuarioToEstado?.id && this.estadoAction) {
      this.usuariosService.updateUsuarioEstado(this.usuarioToEstado.id, this.estadoAction).subscribe(() => {
        const shouldBeActive = this.estadoAction === 'ACTIVAR';
        this.records = this.records.map((record) =>
          record.id === this.usuarioToEstado?.id ? { ...record, activo: shouldBeActive } : record
        );
        this.allDatasearch = this.allDatasearch.map((record) =>
          record.id === this.usuarioToEstado?.id ? { ...record, activo: shouldBeActive } : record
        );
        const estadoSuccessMessage: string = this.estadoAction === 'ACTIVAR'
          ? $localize`:@@activarUsuarioSuccessMessage:Usuario activado correctamente`
          : $localize`:@@desactivarUsuarioSuccessMessage:Usuario desactivado correctamente`;
        this.notificationService.showSuccessNotification(estadoSuccessMessage);
        this.closeEstadoModal();
      });
    }
  }

}
